import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const data = await googleLogin(sessionId);
        navigate(data.client.role === "team" ? "/team" : "/portal", { replace: true, state: { user: data.client } });
      } catch (e) {
        const code = (e.message || "").includes("No account") ? "no_account" : "failed";
        navigate("/login", { replace: true, state: { error: code } });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
